import React from 'react'
import { Helmet } from 'react-helmet'

import * as Styled from './styles/EmbeddedForm.styles'

const RaisersEdgeForm = ({ data }) => {
  if (!data?.raisers_edge_form_id) {
    return null
  }

  return (
    <>
      <Helmet>
        <script
          src="https://bbox.blackbaudhosting.com/webforms/bbox-min.js"
          async
        />
        <script type="text/javascript">
          {`
          window.bboxInit = function () {
            bbox.showForm('${data.raisers_edge_form_id}');
          };`}
        </script>
      </Helmet>
      <Styled.FormContainer>
        <div id="bbox-root">
          {/* <div>
            <div
              dangerouslySetInnerHTML={
                { __html: data.form_embed_code.slice(0, 1).pop().text }
              }
            />
          </div> */}
        </div>
      </Styled.FormContainer>
    </>
  )
}

export default RaisersEdgeForm

// TODO: This should be restored once the solution is in place for embedded forms
// import React from 'react'
// import { Helmet } from 'react-helmet'

// import * as Styled from './styles/EmbeddedForm.styles'

// const RaisersEdgeForm = ({ formId }) => {
//   return (
//     <>
//       <Helmet>
//         <script
//           src="https://bbox.blackbaudhosting.com/webforms/bbox-min.js"
//           async
//         />
//         <script type="text/javascript">
//           {`
//           window.bboxInit = function () {
//             bbox.showForm('${formId}');
//           };`}
//         </script>
//       </Helmet>
//       <Styled.FormContainer>
//         <div id="bbox-root"></div>
//       </Styled.FormContainer>
//     </>
//   )
// }

// export default RaisersEdgeForm
